var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import gql from "graphql-tag";
import * as React from "react";
import { ActivationRequestQrReader } from "./ActivationRequestQrReader";
import { IssueMethod, } from "./admin-gql";
import { IdentityCard } from "./IdentityCard";
import { IssueMethodSelect } from "./IssueMethodSelect";
import { IssueResult } from "./IssueResult";
import { LoaSelect } from "./LoaSelect";
import { Modal } from "./Modal";
import { Spinner } from "./Spinner";
import { isValidIssueMethodForUser } from "./validation";
import i18next from "i18next";
import { Trans } from "react-i18next";
var GuideStep;
(function (GuideStep) {
    GuideStep[GuideStep["ConfirmIdentity"] = 0] = "ConfirmIdentity";
    GuideStep[GuideStep["Loa"] = 1] = "Loa";
    GuideStep[GuideStep["IssueMethod"] = 2] = "IssueMethod";
    GuideStep[GuideStep["QrScan"] = 3] = "QrScan";
    GuideStep[GuideStep["Result"] = 4] = "Result";
})(GuideStep || (GuideStep = {}));
var IssueModal = /** @class */ (function (_super) {
    __extends(IssueModal, _super);
    function IssueModal(props) {
        var _this = _super.call(this, props) || this;
        _this.handleIssueClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var minDelayPromise, result_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState(function (prevState) { return ({
                            issueOperation: { running: true },
                        }); });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 8, , 9]);
                        minDelayPromise = new Promise(function (resolve) {
                            return setTimeout(resolve, 1000);
                        });
                        if (!(this.state.issueMethod === IssueMethod.ACTIVATION_REQUEST)) return [3 /*break*/, 4];
                        return [4 /*yield*/, issueUserToActivationRequest(this.props.user.id, this.state.loa, this.state.qrCode, this.props.context)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, minDelayPromise];
                    case 3:
                        _a.sent();
                        this.setState(function (prevState) { return ({
                            issueOperation: { data: true },
                            step: GuideStep.Result,
                        }); });
                        return [3 /*break*/, 7];
                    case 4: return [4 /*yield*/, issueUser(this.props.user.id, this.state.loa, this.state.issueMethod, this.props.context)];
                    case 5:
                        result_1 = _a.sent();
                        return [4 /*yield*/, minDelayPromise];
                    case 6:
                        _a.sent();
                        this.setState(function (prevState) { return ({
                            issueOperation: { data: result_1.data },
                            step: GuideStep.Result,
                        }); });
                        _a.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_1 = _a.sent();
                        this.setState(function (prevState) { return ({
                            issueOperation: { error: error_1 },
                            step: GuideStep.Result,
                        }); });
                        console.error("Issue user error", error_1);
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            issueMethod: null,
            issueOperation: {},
            step: GuideStep.ConfirmIdentity,
            loa: props.defaultLoa,
            identityConfirmed: false,
        };
        return _this;
    }
    IssueModal.prototype.render = function () {
        var _this = this;
        var props = this.props;
        return (React.createElement(Modal, { header: i18next.t("cc.issue.modal.issue"), onClose: props.onClose }, function (closeModal) {
            switch (_this.state.step) {
                case GuideStep.ConfirmIdentity:
                    return _this.renderConfirmIdentity(closeModal);
                case GuideStep.Loa:
                    return _this.renderLoaStep(closeModal);
                case GuideStep.IssueMethod:
                    return _this.renderIssueMethodStep(closeModal);
                case GuideStep.QrScan:
                    return _this.renderQrScanStep(closeModal);
                case GuideStep.Result:
                    return _this.renderResultStep(closeModal);
                default:
                    return React.createElement("div", null, "Error");
            }
        }));
    };
    IssueModal.prototype.renderConfirmIdentity = function (closeModal) {
        var _this = this;
        var user = this.props.user;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "modal-body" },
                React.createElement("p", null, i18next.t("cc.issue.modal.checkIdentity")),
                React.createElement(IdentityCard, { user: user, className: "mb-3" }),
                React.createElement("div", { className: "form-check mt-2" },
                    React.createElement("label", { className: "form-check-label" },
                        React.createElement("input", { type: "checkbox", className: "form-check-input", checked: this.state.identityConfirmed, onChange: function (ev) {
                                return _this.setState({ identityConfirmed: ev.target.checked });
                            } }),
                        i18next.t("cc.issue.modal.confirmThatIdentityAndRecipientVerified")))),
            React.createElement("div", { className: "modal-footer d-flex justify-content-between" },
                React.createElement("button", { className: "btn btn-secondary", onClick: closeModal, disabled: this.state.issueOperation.running }, i18next.t("cc.issue.modal.cancel")),
                "\u00A0\u00A0",
                React.createElement("button", { className: "btn btn-primary", disabled: !this.state.identityConfirmed, onClick: function () {
                        return _this.setState(function (prevState) { return ({
                            step: !_this.props.defaultLoa
                                ? GuideStep.Loa
                                : GuideStep.IssueMethod,
                        }); });
                    } }, i18next.t("cc.issue.modal.next")))));
    };
    IssueModal.prototype.renderLoaStep = function (closeModal) {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "modal-body" },
                React.createElement("h4", null, i18next.t("cc.issue.modal.selectTrustLevel")),
                React.createElement(LoaSelect, { loa: this.state.loa, onLoaSelect: function (loa) { return _this.setState({ loa: loa }); }, disabled: this.state.issueOperation.running })),
            React.createElement("div", { className: "modal-footer d-flex justify-content-between" },
                React.createElement("button", { className: "btn btn-secondary", onClick: function () { return _this.setState({ step: GuideStep.ConfirmIdentity }); }, disabled: this.state.issueOperation.running }, i18next.t("cc.issue.modal.back")),
                "\u00A0\u00A0",
                React.createElement("button", { className: "btn btn-primary", disabled: !this.state.loa, onClick: function () {
                        return _this.setState(function (prevState) { return ({ step: GuideStep.IssueMethod }); });
                    } }, i18next.t("cc.issue.modal.next")))));
    };
    IssueModal.prototype.renderIssueMethodStep = function (closeModal) {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "modal-body" },
                React.createElement("h4", null, i18next.t("cc.issue.modal.selectMethod")),
                React.createElement(IssueMethodSelect, { disabledPredicate: function (method) {
                        return _this.state.issueOperation.running ||
                            !isValidIssueMethodForUser(method, _this.state.loa, _this.props.user);
                    }, onIssueMethodChanged: function (newMethod) {
                        return _this.setState({ issueMethod: newMethod });
                    }, issueMethod: this.state.issueMethod })),
            React.createElement("div", { className: "modal-footer d-flex justify-content-between" },
                React.createElement("button", { className: "btn btn-secondary", onClick: function () {
                        return _this.setState({
                            step: !_this.props.defaultLoa
                                ? GuideStep.Loa
                                : GuideStep.ConfirmIdentity,
                        });
                    }, disabled: this.state.issueOperation.running }, i18next.t("cc.issue.modal.back")),
                "\u00A0\u00A0",
                this.state.issueMethod === IssueMethod.ACTIVATION_REQUEST ? (React.createElement("button", { className: "btn btn-primary", onClick: function () { return _this.setState({ step: GuideStep.QrScan }); } }, i18next.t("cc.issue.modal.next"))) : (React.createElement("button", { className: "btn btn-primary", onClick: function () { return _this.handleIssueClick(); }, disabled: this.state.issueMethod === null ||
                        this.state.issueOperation.running }, this.state.issueOperation.running ? i18next.t("cc.issue.modal.issuing") : i18next.t("cc.issue.modal.issue"))))));
    };
    IssueModal.prototype.renderQrScanStep = function (closeModal) {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "modal-body" }, this.state.qrCode ? (React.createElement("p", null,
                React.createElement(Trans, { i18nKey: "cc.issue.modal.qrCode" }),
                " ")) : (React.createElement(ActivationRequestQrReader, { onActivationRequestId: function (id) { return _this.setState({ qrCode: id }); }, disabled: this.state.issueOperation.running }))),
            React.createElement("div", { className: "modal-footer d-flex justify-content-between align-items-center" },
                React.createElement("button", { className: "btn btn-secondary", onClick: function () {
                        return _this.setState({ step: GuideStep.IssueMethod, qrCode: null });
                    }, disabled: this.state.issueOperation.running }, i18next.t("cc.issue.modal.back")),
                this.state.issueOperation.running ? React.createElement(Spinner, null) : null,
                React.createElement("button", { className: "btn btn-primary", onClick: function () { return _this.handleIssueClick(); }, disabled: this.state.issueOperation.running || !this.state.qrCode }, i18next.t("cc.issue.modal.issue")))));
    };
    IssueModal.prototype.renderResultStep = function (closeModal) {
        var regularIssueResult = this.state.issueOperation.data &&
            typeof this.state.issueOperation.data !== "boolean" &&
            this.state.issueOperation.data.issueUser;
        var activationRequestIssueResult = this.state.issueOperation.data &&
            typeof this.state.issueOperation.data === "boolean";
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "modal-body" },
                regularIssueResult ? (React.createElement(IssueResult, __assign({}, regularIssueResult, { user: this.props.user, skolidUrl: this.props.skolidUrl }))) : null,
                activationRequestIssueResult ? React.createElement("p", null, i18next.t("cc.issue.modal.accountIsIssued")) : null,
                this.state.issueOperation.error ? (React.createElement("div", { className: "alert alert-danger", role: "alert" }, i18next.t("cc.issue.modal.failedIssueAccount"))) : null),
            React.createElement("div", { className: "modal-footer text-right" },
                React.createElement("button", { className: "btn btn-primary", onClick: closeModal, disabled: this.state.issueOperation.running }, i18next.t("cc.issue.modal.okay")))));
    };
    return IssueModal;
}(React.PureComponent));
export { IssueModal };
export function issueUser(userId, loa, issueMethod, context) {
    return __awaiter(this, void 0, void 0, function () {
        var client, signManager, signPopup, mutationArguments, contractResponse, contract, signature, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    client = context.client, signManager = context.signManager;
                    signPopup = signManager.openPopup();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    mutationArguments = {
                        userId: userId,
                        options: {
                            method: issueMethod,
                            loa: loa,
                        },
                    };
                    return [4 /*yield*/, client.mutate({
                            mutation: generateIssueUserContractGql,
                            variables: mutationArguments,
                        })];
                case 2:
                    contractResponse = (_a.sent());
                    contract = contractResponse.data.generateIssueUserContract;
                    return [4 /*yield*/, signManager.sign(contract.text, contract.data, signPopup)];
                case 3:
                    signature = _a.sent();
                    return [2 /*return*/, client.mutate({
                            mutation: issueUserGql,
                            // tslint:disable-next-line:no-object-literal-type-assertion
                            variables: __assign(__assign({}, mutationArguments), { signature: signature }),
                        })];
                case 4:
                    error_2 = _a.sent();
                    signPopup.close();
                    throw error_2;
                case 5: return [2 /*return*/];
            }
        });
    });
}
var generateIssueUserContractGql = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation GenerateIssueUserContract(\n    $userId: String!\n    $options: IssueUserOptionsInput!\n  ) {\n    generateIssueUserContract(userId: $userId, options: $options) {\n      text\n      data\n    }\n  }\n"], ["\n  mutation GenerateIssueUserContract(\n    $userId: String!\n    $options: IssueUserOptionsInput!\n  ) {\n    generateIssueUserContract(userId: $userId, options: $options) {\n      text\n      data\n    }\n  }\n"])));
var issueUserGql = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  mutation IssueUser(\n    $userId: String!\n    $options: IssueUserOptionsInput!\n    $signature: String!\n  ) {\n    issueUser(userId: $userId, options: $options, signature: $signature) {\n      user {\n        id\n      }\n      activationCode\n      activationCodeExpiresAt\n    }\n  }\n"], ["\n  mutation IssueUser(\n    $userId: String!\n    $options: IssueUserOptionsInput!\n    $signature: String!\n  ) {\n    issueUser(userId: $userId, options: $options, signature: $signature) {\n      user {\n        id\n      }\n      activationCode\n      activationCodeExpiresAt\n    }\n  }\n"])));
var issueUserToActivationRequestGql = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  mutation IssueByQrCode(\n    $userId: String!\n    $code: String!\n    $signature: String!\n    $options: IssueUserOptionsInput!\n  ) {\n    issueUserToActivationRequest(\n      userId: $userId\n      activationRequestId: $code\n      options: $options\n      signature: $signature\n    ) {\n      user {\n        id\n      }\n    }\n  }\n"], ["\n  mutation IssueByQrCode(\n    $userId: String!\n    $code: String!\n    $signature: String!\n    $options: IssueUserOptionsInput!\n  ) {\n    issueUserToActivationRequest(\n      userId: $userId\n      activationRequestId: $code\n      options: $options\n      signature: $signature\n    ) {\n      user {\n        id\n      }\n    }\n  }\n"])));
export function issueUserToActivationRequest(targetId, loa, activationRequestId, context, refetchQueries, signPopup) {
    return __awaiter(this, void 0, void 0, function () {
        var response, contract, signature, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    signPopup = signPopup || context.signManager.openPopup();
                    return [4 /*yield*/, context.client.mutate({
                            mutation: generateIssueUserContractGql,
                            variables: {
                                userId: targetId,
                                options: {
                                    loa: loa,
                                    method: IssueMethod.ACTIVATION_REQUEST,
                                },
                            },
                        })];
                case 1:
                    response = _a.sent();
                    contract = response.data.generateIssueUserContract;
                    return [4 /*yield*/, context.signManager.sign(contract.text, contract.data, signPopup)];
                case 2:
                    signature = _a.sent();
                    return [4 /*yield*/, context.client.mutate({
                            mutation: issueUserToActivationRequestGql,
                            awaitRefetchQueries: true,
                            refetchQueries: refetchQueries,
                            variables: {
                                code: activationRequestId,
                                options: {
                                    loa: loa,
                                    method: IssueMethod.ACTIVATION_REQUEST,
                                },
                                userId: targetId,
                                signature: signature,
                            },
                        })];
                case 3:
                    result = (_a.sent());
                    return [2 /*return*/, result.data];
            }
        });
    });
}
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=IssueModal.js.map